export const memberCarePlanKeys = {
  articulatedGoals: (patientId: string) =>
    [...memberCarePlanKeys.base, patientId, "articulatedGoals"] as const,
  base: ["care-plan"] as const,
  careTeam: (patientId: string) => [...memberCarePlanKeys.base, patientId, "careTeam"] as const,
  detail: (patientId: string) => [...memberCarePlanKeys.base, patientId] as const,
  goalAndObjectiveText: (patientId: string) =>
    [...memberCarePlanKeys.base, patientId, "goalAndObjectiveText"] as const,
  goalsAndObjectives: (patientId: string) =>
    [...memberCarePlanKeys.base, patientId, "goalsAndObjectives"] as const,
  medicalCautions: (patientId: string) =>
    [...memberCarePlanKeys.base, patientId, "medicalCautions"] as const,
  modalityText: (patientId: string) =>
    [...memberCarePlanKeys.base, patientId, "modalityText"] as const,
  strengthCautionOptions: (patientId: string) =>
    [...memberCarePlanKeys.base, patientId, "strengthCautionOptions"] as const,
  strengths: (patientId: string) => [...memberCarePlanKeys.base, patientId, "strengths"] as const,
} as const;
